import IndexPage from "./IndexPage";

const keyName='AdminPage';
export default class AdminPage extends IndexPage {
}

